<div class="ws-popup-header">
  <span>{{'E-mail to the beneficiary' | translate}}</span>
  <div class="actions">
    <button mat-icon-button (click)="closeClicked()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content">
  <form [formGroup]="form">
    <div class="input-wrapper">
      <label for="email">
        {{'Email' | translate}}:
      </label>
      <input matInput id="email" type="email" formControlName="email">
    </div>
  </form>
</div>

<div class="ws-popup-footer">
  <span></span>
  <div class="actions-footer">
    <ws-button [callToActionType]="'tertiary'" (click)="closeClicked()">
      {{ 'Back' | translate }}
    </ws-button>
    <ws-button [callToActionType]="'primary'" (click)="sendClicked()">
      {{ 'Send' | translate }}
    </ws-button>
  </div>
</div>
